/* eslint-disable no-console */
export default class SiteModal {
  constructor(options) {
    if (!options.callbacks) {
      options.callbacks = {};
    }
    this.onOpen = options.callbacks.onOpen;
    this.onClose = options.callbacks.onClose;
    this.modalDiv = document.querySelector(`#${options.id}`);
    this.isOpen = false;
    this.previousElementInFocus = null;
    // Modal events
    window.addEventListener('resize', this.onResize.bind(this));
    [].map.call(this.modalDiv.querySelectorAll('.close-btn, .modal-overlay, #modal-refine-btn'), btn => btn.addEventListener('click', this.close.bind(this)));
    document.addEventListener('keyup', this.onDocumentModalKeyUp.bind(this));
    // Add open to toggleBtn
    if (options.toggleBtn) {
      options.toggleBtn.addEventListener('click', this.open.bind(this));
    }
  }

  onDocumentModalKeyUp(event) {
    if (event.keyCode === 27 && this.isOpen) {
      this.close(); /* eslint-disable-line no-use-before-define */
    }
  }

  setPreviousElementInFocus(element) {
    this.previousElementInFocus = element;
  }

  resetFocus() {
    if (this.previousElementInFocus) {
      this.previousElementInFocus.focus();
    }
  }

  updateHeight() {
    console.log('id:', this.modalDiv.id);
    if (!this.isOpen) {
      return;
    }
    const contentHeight = this.modalDiv.querySelector('.modal-content').offsetHeight;
    console.log('updateheight');
    this.modalDiv.querySelector('.modal-panel').style.height = `${contentHeight + 30}px`;
  }

  onResize() {
    if (!this.isOpen) {
      return;
    }
    this.updateHeight();
  }

  close() {
    this.isOpen = false;
    if (this.onClose) {
      this.onClose();
    }
    this.modalDiv.classList.remove('modal-visible');
    this.resetFocus();
  }

  open() {
    this.isOpen = true;
    this.modalDiv.classList.add('modal-visible');
    if (this.onOpen) {
      this.onOpen();
    }
    this.setPreviousElementInFocus(document.activeElement);
    this.modalDiv.focus();
    this.updateHeight();
  }
}
/* eslint-enable no-console */
